module.exports = __webpack_public_path__ + "img/volleyball.84661fcf.jpg";